<template>
  <section class="guides-section">
    <div class="guides-section__container">
      <div class="section-header">
        <h2 class="section-header__title">GAMING GUIDES</h2>
        <div class="section-header__line"></div>
        <a href="/guides/" class="section-header__link">SEE ALL</a>
      </div>

      <div v-if="guideArticles.length > 0" class="guides-grid">
        <article
          v-for="article in guideArticles"
          :key="article.slug"
          class="brutal-card"
        >
          <a :href="`/${article.category}/${article.slug}/`" class="brutal-card__link">
            <div v-if="article.featuredImage || article.image" class="brutal-card__image">
              <img :src="article.featuredImage || article.image" :alt="article.title" />
            </div>
            <div class="brutal-card__content">
              <div class="brutal-card__meta">
                <span class="brutal-card__tag">{{ article.subcategory || 'GUIDE' }}</span>
              </div>
              <h3 class="brutal-card__title">{{ article.title }}</h3>
            </div>
          </a>
        </article>
      </div>
      <div v-else class="empty-state">
        <p>NO GUIDES DETECTED.</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'GuidesSection',
  computed: {
    guideArticles() {
      const articles = this.$store.getters['articles/getArticlesByCategory']('guides')
      return articles ? articles.slice(0, 4) : []
    },
  },
}
</script>

<style lang="scss" scoped>
.guides-section {
  padding: rem(48) 0;
  background: $bg-primary;
}

.guides-section__container {
  max-width: $container-max-width;
  margin: 0 auto;
  padding: 0 rem(24);
}

.section-header {
  display: flex;
  align-items: center;
  gap: rem(24);
  margin-bottom: rem(48);

  &__title {
    font-size: rem(32);
    color: $text-primary;
    font-weight: 900;
    font-family: $font-family-heading;
    text-transform: uppercase;
    letter-spacing: 1px;
    margin: 0;
  }

  &__line {
    flex: 1;
    height: 2px;
    background-color: $border-color;
  }

  &__link {
    color: $primary-color;
    font-family: $font-family-heading;
    font-size: rem(16);
    font-weight: 900;
    text-transform: uppercase;
    text-decoration: none;
    letter-spacing: 1px;
    transition: color $transition-speed;

    &:hover {
      color: $text-primary;
    }
  }
}

.guides-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: rem(24);

  @include pc {
    grid-template-columns: repeat(4, 1fr);
    gap: rem(24);
  }
}

.brutal-card {
  background: $bg-secondary;
  border: 1px solid $border-color;
  display: flex;
  flex-direction: column;
  @include brutal-hover;

  &__link {
    display: flex;
    flex-direction: column;
    height: 100%;
    text-decoration: none;
    color: inherit;
  }

  &__image {
    width: 100%;
    height: rem(180);
    overflow: hidden;
    border-bottom: 1px solid $border-color;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: filter 0.3s;
      filter: grayscale(10%);
    }
  }

  &:hover &__image img {
    filter: grayscale(0%);
  }

  &__content {
    padding: rem(20);
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  &__meta {
    display: flex;
    justify-content: flex-start;
    margin-bottom: rem(12);
  }

  &__tag {
    color: $primary-color;
    font-size: rem(12);
    font-weight: 900;
    font-family: $font-family-heading;
    text-transform: uppercase;
    letter-spacing: 1px;
  }

  &__title {
    font-size: rem(20);
    color: $text-primary;
    margin: 0;
    line-height: 1.2;
    font-family: $font-family-heading;
    font-weight: 900;
    text-transform: uppercase;
  }
}

.empty-state {
  text-align: center;
  padding: rem(64);
  font-family: $font-family-heading;
  font-weight: 900;
  font-size: rem(24);
  color: $text-muted;
  border: 2px dashed $border-color;
  text-transform: uppercase;
}
</style>
